import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'
import TwoColumnErrorPage from 'shared/ErrorPages/TwoColumnErrorPage'
import checkStatus from 'shared/utils/checkStatus'

import styles from './IATAScanResultMessage.style'

const propTypes = {
    resultStatus: PropTypes.string,
    scanResult: PropTypes.string,
    containerTempRange: PropTypes.string,
    onRetry: PropTypes.func.isRequired,
}

const IATAScanResultMessage = ({
    resultStatus = '',
    scanResult = '',
    containerTempRange = '',
    onRetry,
}) => {
    const classes = useStyle(styles)
    const { t } = useTranslation()

    const texts = useMemo(() => {
        return [
            {
                label: `${t('STICKER')}: `,
                value: scanResult,
            },
            {
                label: `${t('CONTAINER')}: `,
                value: containerTempRange,
            },
        ]
    }, [
        scanResult,
        containerTempRange,
        t,
    ])

    return (
        <>
            { resultStatus === checkStatus.SUCCESS && (
                <div css={classes.success}>
                    {t('CORRECT_STICKER', { tempRange: scanResult })}
                </div>
            )}

            { resultStatus === checkStatus.FAILURE && (
                <TwoColumnErrorPage
                    iconPath="skycenter/not_found.svg"
                    iconAlt="logo"
                    buttonLabel={t('RETRY')}
                    onButtonClick={onRetry}
                    buttonDataTestId="retry-button"
                    messageTop={t('WRONG_STICKER_PART_ONE')}
                    messageBottom={t('WRONG_STICKER_PART_TWO')}
                    middleTexts={texts}
                />
            )}
        </>
    )
}

IATAScanResultMessage.propTypes = propTypes

export default IATAScanResultMessage
